import React, { useState } from "react";
import LogoImg from "../assets/Mothers-Pride-Logo-1024x283 6.png";
import { useNavigate } from "react-router-dom";
import Subscribe from "./Subscribe";
import { IoLogoYoutube } from "react-icons/io";
import { FaLinkedin } from "react-icons/fa";
import { AiFillInstagram } from "react-icons/ai";
import { FaFacebookSquare } from "react-icons/fa";

export default function Footer({ marginX }) {
  const [SubscribeModal, setOpenModal] = useState(false);
  const navigate = useNavigate();

  return (
    <div className="text-center w-full relative">
      {/* Top Section */}

      <div
        className={`flex md:flex-row items-center sm:items-center justify-between mt-[100px] sm:mt-20 text-sm gap-2 sm:text-lg text-[#D31C4F] font-semibold pb-2 sm:pb-8 mx-auto border-b border-[#7F7F7F] sm:px-4`}
        style={{
          marginLeft: marginX ? marginX : "5%",
          marginRight: marginX ? marginX : "5%",
        }}
      >
        <button onClick={() => setOpenModal(true)}>Subscribe</button>
        <button onClick={() => navigate("/terms&Conditions")}>
          Terms & Conditions
        </button>
        <img
          src={LogoImg}
          className="text-2xl h-[46px] cursor-pointer sm:flex hidden"
          alt="logo"
          onClick={() => navigate("/")}
        />
        <button onClick={() => navigate("/privacy")}>Privacy Policy</button>
        <button onClick={() => navigate("/getinTouch")}>Contact Us</button>
      </div>

      <img
        src={LogoImg}
        className="text-2xl h-[46px] sm:hidden sm:relative absolute top-[-60px] left-[25%]"
        alt="logo"
        onClick={() => navigate("/")}
      />

      {/* Social Media Buttons */}
      <div
        style={{
          marginLeft: marginX ? marginX : "5%",
          marginRight: marginX ? marginX : "5%",
        }}
        className="text-[#D31C4F] sm:text-xl font-bold flex flex-wrap  justify-center lg:gap-10 gap-4 mt-4 sm:mt-8 mb-[30px] sm:mb-6 "
      >
        <button
          className="flex items-center px-1 sm:px-4 py-1 border border-[#D31C4F] rounded-full sm:py-2 sm:w-40 justify-between"
          onClick={() =>
            window.open(
              "https://www.instagram.com/motherspridepreschool/",
              "_blank",
              "noopener",
              "noreferrer"
            )
          }
        >
          <AiFillInstagram className="w-5 sm:w-7" />
          <p className="sm:block hidden">Instagram</p>
        </button>
        <button
          className="flex items-center px-1 sm:px-4 py-1 border border-[#D31C4F] rounded-full sm:py-2 sm:w-40 justify-between"
          onClick={() =>
            window.open(
              "https://www.facebook.com/mothersprideonline/",
              "_blank",
              "noopener",
              "noreferrer"
            )
          }
        >
          <FaFacebookSquare className="w-5 sm:w-7" />
          <p className="sm:block hidden">Facebook</p>
        </button>
        <button
          className="flex items-center px-1 sm:px-4 py-1 border border-[#D31C4F] rounded-full sm:py-2 sm:w-40 justify-between"
          onClick={() =>
            window.open(
              "https://www.youtube.com/@mothersprideschools",
              "_blank",
              "noopener",
              "noreferrer"
            )
          }
        >
          <IoLogoYoutube className="w-5 sm:w-7" />
          <p className="sm:block hidden">Youtube</p>
        </button>
        <button
          className="flex items-center  px-1 sm:px-4 py-1 border border-[#D31C4F] rounded-full sm:py-2 sm:w-40 justify-between"
          onClick={() =>
            window.open(
              "https://in.linkedin.com/company/mother-s-pride",
              "_blank",
              "noopener",
              "noreferrer"
            )
          }
        >
          <FaLinkedin className="w-5 sm:w-7" />
          <p className="sm:block hidden">Linkedin</p>
        </button>
      </div>

      {/* Subscribe Modal */}
      {SubscribeModal && <Subscribe setOpenModal={setOpenModal} />}
    </div>
  );
}
